<template>
	<div v-show="show">
		<div class="vx-card p-6">
			<vs-row v-if="teamCreatePermission">
				<div class="vx-col w-full mb-base p-4">
					<div class="flex justify-between flex-wrap">
						<TeamsForm :data="skillItem" :isEditActive="false" />
					</div>
				</div>
			</vs-row>
			<not-permission v-else></not-permission>
		</div>
	</div>
</template>

<script>
import TeamsForm from "@/components/teams/TeamsForm.vue";
import NotPermission from "@/views/pages/NotPermission.vue";

export default {
	name: "CreateTeam",
	components: {
		TeamsForm,
		NotPermission,
	},
	data() {
		return {
			skillItem: {},
			show: false,
		};
	},
	computed: {
		teamCreatePermission() {
			return this.$store.getters.checkPermission("TEAMS_C");
		},
	},
	mounted() {
		this.show = true;
	},
};
</script>
